import { TEXT } from './00_assets_types'

const ES =
{
  [ TEXT.UI_MENU_USERS         ]: 'Benutzer'
, [ TEXT.UI_MENU_CLIENTS       ]: 'Kunden'
, [ TEXT.UI_MENU_WORKGROUPS    ]: 'Arbeitsgruppen'
, [ TEXT.UI_MENU_JOBS          ]: 'Arbeitsplätze'
, [ TEXT.UI_MENU_KEY_MASTERING  ]: 'Hauptschlüsselsystem'

, [ TEXT.UI_BUTTON_CREATE      ]: 'Erstellen'
, [ TEXT.UI_BUTTON_NEW         ]: 'Neu'
, [ TEXT.UI_BUTTON_OK          ]: 'Okay'
, [ TEXT.UI_BUTTON_CANCEL      ]: 'Aufheben'
, [ TEXT.UI_BUTTON_SAVE        ]: 'Speichern'
, [ TEXT.UI_BUTTON_LOGIN       ]: 'Login'
, [ TEXT.UI_BUTTON_SEND        ]: 'Senden'


, [ TEXT.UI_EMAIL              ]: 'Email'
, [ TEXT.UI_ROLE               ]: 'Rolle'
, [ TEXT.UI_USERNAME           ]: 'Benutzer'
, [ TEXT.UI_NAME               ]: 'Name'
, [ TEXT.UI_DATE               ]: 'Datum'
, [ TEXT.UI_ADDR               ]: 'Adresse'
, [ TEXT.UI_DESC               ]: 'Beschreibung'
, [ TEXT.UI_PRICE              ]: 'Preis'
, [ TEXT.UI_NO_DATA            ]: 'Keine Daten'
, [ TEXT.UI_MACHINES           ]: 'Maschinen'
, [ TEXT.UI_USERS              ]: 'Benutzer'
, [ TEXT.UI_DATE_FORMAT        ]: 'DD/MM/YYYY' // ES - date format Locale
, [ TEXT.UI_SING_OUT           ]: 'Ausloggen'
, [ TEXT.UI_MKS_TYPE           ]: 'Hauptschlüsselsystemtyp'
, [ TEXT.UI_KEY_APP            ]: 'Verwendung des Schlüssels'
, [ TEXT.UI_CLIENT             ]: 'Klient'
, [ TEXT.UI_FILE               ]: 'Datei'
, [ TEXT.UI_SELECT_FILE        ]: 'Datei aussuchen'


, [ TEXT.UI_LOGIN_USERNAME     ]: 'Benutzer'
, [ TEXT.UI_LOGIN_CLOUDNAME    ]: 'Cloud'
, [ TEXT.UI_LOGIN_PASSWORD     ]: 'Passwort'



, [ TEXT.ARE_YOU_SURE          ]: 'Bist du sicher?'


, [ TEXT.ERROR_NONE            ]: ''
, [ TEXT.ERROR_LOGIN_FORBIDDEN ]: 'Falscher Benutzer / Cloud oder Passwort'
, [ TEXT.ERROR_LOGIN_UNAUTHORIZED ]: 'Falscher Benutzer / Cloud oder Passwort'
, [ TEXT.ERROR_INTERNAL        ]: 'interner Serverfehler'
, [ TEXT.ERROR_FORBIDDEN       ]: 'Zugriff abgelehnt'
, [ TEXT.ERROR_UNKNOWN         ]: 'Es ist ein Fehler aufgetreten, und das ist alles, was wir wissen'

, [ TEXT.PAGE_NOT_FOUND        ]: 'Seite nicht gefunden'

, [ TEXT.WORKGROUPS_NEW_TITLE  ]: 'Neue Arbeitsgruppe'
, [ TEXT.WORKGROUPS_EDIT_TITLE ]: 'Arbeitsgruppe bearbeiten'
, [ TEXT.WORKGROUPS_NAME       ]: 'Name'


, [ TEXT.USERS_NEW_TITLE       ]: 'Neuer Benutzer'
, [ TEXT.USERS_EDIT_TITLE      ]: 'Benutzer bearbeiten'


, [ TEXT.MACHINE_TYPE          ]: 'Maschinentyp'
, [ TEXT.MACHINE_NUM_JOBS      ]: '# Arbeitsplätze'
, [ TEXT.MACHINE_NAME          ]: 'Maschine'


, [ TEXT.CLIENT_NEW_TITLE      ]: 'Neuer Kunde'
, [ TEXT.CLIENT_EDIT_TITLE     ]: 'Kunden bearbeiten'
, [ TEXT.CLIENT_ADDRESS        ]: 'Adresse'
, [ TEXT.CLIENT_CONTACT        ]: 'Kontakt'
, [ TEXT.CLIENT_CONTACT_EMAIL  ]: 'Email'
, [ TEXT.CLIENT_CONTACT_PHONE  ]: 'Telefon'
, [ TEXT.CLIENT_CONTACT_FAX    ]: 'Fax/Tlf'
, [ TEXT.CLIENT_SURNAMES       ]: 'Nachname'
, [ TEXT.CLIENT_BIRTHDAY       ]: 'Geburtstag'
, [ TEXT.CLIENT_NOTES          ]: 'Anmerkungen'
, [ TEXT.CLIENTS_FILTER_BY_NAME ]: 'Filtername'
, [ TEXT.CLIENTS_FILTER_BY_ADDR ]: 'Filteradresse'
, [ TEXT.CLIENTS_FILTER_BY_CONTACT ]: 'Kontakt filtern'
, [ TEXT.CLIENT_ADDR_STREET1   ]: 'Adresse'
, [ TEXT.CLIENT_ADDR_STREET2   ]: ''
, [ TEXT.CLIENT_ADDR_CITY      ]: 'Stadt'
, [ TEXT.CLIENT_ADDR_PROVINCE  ]: 'Provinz'
, [ TEXT.CLIENT_ADDR_ZIP_CODE  ]: 'Postleitzahl'
, [ TEXT.CLIENT_ADDR_COUNTRY   ]: 'Land'


, [ TEXT.MACHINES_NEW          ]: 'Neue Maschine'
, [ TEXT.MACHINE_SERIAL_NO     ]: 'Ordnungsnummer'

, [ TEXT.JOB_EDIT_TITLE        ]: 'Job bearbeiten'
, [ TEXT.JOB_NEW_TITLE         ]: 'Neuer Job'
, [ TEXT.JOB_KEY_TYPE          ]: 'Schlüsselart'
, [ TEXT.JOB_NUM_KEYS          ]: 'Menge'
, [ TEXT.JOB_MACHINE           ]: 'Maschine'
, [ TEXT.JOB_STATUS            ]: 'Status'
, [ TEXT.JOB_DATE              ]: 'Datum'
, [ TEXT.JOB_QUANTITY          ]: 'Neue Menge'
, [ TEXT.JOB_FILTER_BY_STATUS  ]: 'Filterstatus'
, [ TEXT.JOB_FILTER_BY_CLIENT  ]: 'Clients filtern'
, [ TEXT.JOB_FILTER_BY_MACHINE_NAME ]: 'Filtermaschine'
, [ TEXT.JOB_FILTER_BY_KEY_TYPE]: 'Filter Key Type'
, [ TEXT.JOB_FILTER_BY_DATE    ]: 'Filter Date'

, [ TEXT.KEY_MASTERING_LAUNCH             ]: 'Start'
, [ TEXT.KEY_MASTERING_LAUNCH_N           ]: 'Start ({num})'
, [ TEXT.KEY_MASTERING_NEW_TITLE          ]: 'Laden Sie das Hauptschlüsselsystem hoch'
, [ TEXT.KEY_MASTERING_WILL_CREATE_N_KEYS ]: '{num} Schlüssel werden erstellt. Bist du sicher?'
, [ TEXT.KEY_MASTERING_KEYS_CREATED       ]: '{num} Arbeitsplätze wurden geschaffen'
, [ TEXT.KEY_MASTERING_NAME               ]: 'Name des Hauptschlüsselsystems'

, [ TEXT.LOGIN_FORGOT_PASSWORD_QUESTION ]: 'Passwort vergessen?'
, [ TEXT.LOGIN_FORGOT_PASSWORD_TITLE ]: 'Senden Sie die Anweisungen zum Ausruhen an'
, [ TEXT.LOGIN_SLOGAN                   ]: 'Die erste Cloud-basierte App zur Schlüsselvervielfältigung'
, [ TEXT.LOGIN_QUALITY_POINTS           ]: `
<br>
<br>
<p class="login-quality-call mb-4">
  <strong>THE FUTURE OF KEY DUPLICATION</strong>
</p>annulliert
<ul class="login-sell-points">
  <li>Speichern Sie die Auftragsdaten (Schlüssel-Codes/ -Referenzen für die Duplikation) Ihrer Kunden</li>
  <br>
  <li>Sichere Datenspeicherung und ortsunabhängiger Zugriff</li>
  <br>
  <li>Automatische Updates</li>
</ul>
`

, [ TEXT.LEGAL_TOS_TEXT              ]: 'Rechtliche Hinweise'
, [ TEXT.LEGAL_PRIVACY_TEXT          ]: 'Datenschutzbestimmungen'
, [ TEXT.LEGAL_MODEL_TEXT            ]: 'Vertragsmodell'
, [ TEXT.LEGAL_TOS_LINK              ]: '/legal/de/legal_notice_de.pdf'
, [ TEXT.LEGAL_PRIVACY_LINK          ]: '/legal/de/privacy_policy_de.pdf'
, [ TEXT.LEGAL_MODEL_LINK            ]: '/legal/de/model_de.docx'

, [ TEXT.KEY_MODEL                   ]: 'Schlüssel'
, [ TEXT.KEY_SERIES                  ]: 'Serie'
, [ TEXT.KEY_CODE                    ]: 'Code'
, [ TEXT.KEY_DATA_SHEET              ]: 'Datei'
, [ TEXT.KEY_BITING                  ]: 'Beißen'
, [ TEXT.KEY_APPLICATION             ]: 'Anwendung'

, [ TEXT.ENUM_JOB_STATE_PENDING      ]: 'STEHT AUS'
, [ TEXT.ENUM_JOB_STATE_CANCELLED    ]: 'ANNULLIERT'
, [ TEXT.ENUM_JOB_STATE_COMPLETE     ]: 'KOMPLETT'
, [ TEXT.ENUM_JOB_STATE_PROCESSING   ]: 'WIRD BEARBEITET'

, [ TEXT.ENUM_USER_ROLE_ADMIN        ]: 'ADMIN'
, [ TEXT.ENUM_USER_ROLE_MANAGER      ]: 'MANAGER'
, [ TEXT.ENUM_USER_ROLE_USER         ]: 'USER'

, [ TEXT.ENUM_KEY_APP_CAR            ]: 'AUTO'
, [ TEXT.ENUM_KEY_APP_HOME           ]: 'HAUS'
, [ TEXT.ENUM_KEY_APP_SECURITY       ]: 'SICHERHEIT'
, [ TEXT.ENUM_KEY_APP_LOCK           ]: 'VORHÄNGESCHLOSS'
, [ TEXT.ENUM_KEY_APP_UNSPECIFIED    ]: 'NICHT SPEZIFIZIERT'

, [ TEXT.FORM_HAS_ERRORS             ]: 'Bitte füllen Sie die Pflichtfelder rot aus'
}

export default ES ;
